import React, {useContext} from 'react';
import {injectIntl} from "react-intl";
import SelectField from "@FormElements/SelectField";
import FormContext from "formContext";

function NoticePeriodField({intl, settings, ...rest}) {
  const {additionalData: {masterLists}} = useContext(FormContext);

  settings.options = [{
    value: '',
    label: intl.formatMessage({id: 'Register.Form.NoticePeriod.Field.EmptyOption'})
  }];

  if (masterLists && masterLists.hasOwnProperty('NoticePeriods')) {
    const {NoticePeriods} = masterLists;
    if (NoticePeriods.length) {
      NoticePeriods.forEach(period => {
        if (period.ListValue !== 'Available From') {
          settings.options.push({
            value: period.Code,
            label: period.ListValue
          });
        }
      });
    }
  }
  return (
    <SelectField
      settings={settings}
      {...rest}
    />
  )

}

export default injectIntl(NoticePeriodField);
